var map = {
	"./GenI.png": 48322,
	"./GenII.png": 88745,
	"./GenIII.png": 82364,
	"./GenIV.png": 22574,
	"./GenIX.png": 38736,
	"./GenV.png": 77557,
	"./GenVI.png": 69744,
	"./GenVII.png": 13971,
	"./GenVIII.png": 22474
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68012;